import React from "react";
import PageLayout from "./PageLayout";
import ParentReviews from "../sections/ParentReviews";

export default function ReviewsPage() {
    return (
        <PageLayout testId="reviews-page" pageTitle="Valideyn rəyləri">
            <ParentReviews standalone />
        </PageLayout>
    );
}
